import { get } from "./api";

export const getSalesReport = (q) => get("/sales-report", { params: { q } });

export const getSalesTrends = (q) => get("/sales-trends", { params: { q } });

export const fetchMonthlySalesReportsData = (q) =>
  get("/monthly-sales-overview", { params: { q } });
